<template>
    <div class="bg-a-egg-f5ebdc h-screen"></div>
</template>

<script>
//config
import ConfigManager from '@/config/ConfigManager.js';
//helper
import CacheHelper from "@/helper/CacheHelper";
export default {
    data: function() {
        return {
            tranId: this.$route.query.tranId,
            KEY_COOKIE_RETURN_URL: 'return_url',
        }
    },
    created: function() {
        this.gotoMyOrder();
    },
    methods: {
        gotoMyOrder: function() {
            let cache = new CacheHelper(ConfigManager.getCacheType());
            let cacheReturnUrl = cache.getCache(this.KEY_COOKIE_RETURN_URL);
            if (cacheReturnUrl) {
                cache.removeCache(this.KEY_COOKIE_RETURN_URL);
                cacheReturnUrl += "mypackage?tranId=" + this.tranId;
                
                setTimeout(()=>{
                    window.location.href = cacheReturnUrl;
                },1000); 
            } else {
                this.$router.replace("/subscription/mypackage?from=shoppingcart");
            }
        },
    }
}
</script>

<style>

</style>